import type { DownloadUrl } from '../api/types';

/**
 * Open a presigned file URL. The window is opened synchronously inside the tap (popup blockers on phones),
 * then pointed at the URL once the API answers.
 */
export async function openFile(get: () => Promise<DownloadUrl>): Promise<void> {
  let w: Window | null = null;
  try {
    w = window.open('', '_blank');
  } catch {
    w = null;
  }
  try {
    const r = await get();
    if (w && !w.closed) w.location.href = r.url;
    else window.location.href = r.url;
  } catch (e) {
    w?.close();
    throw e;
  }
}
